import { dataAttrs } from 'Helpers/Testing';
import { FDAvatar, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import MetaControl from 'Components/UI/Meta/MetaControl';
import React from 'react';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import PropTypes from 'prop-types';
import { BorderedTransparentBox } from 'Packages/FacetDesign/Components/Experimental/BorderedTransparentBox';

const metaOverrides = buildFacetDesignOverride();

export const NextUpInsight = ({ resource }) => {
  if (!resource.attr('nextUpCustomInsight')) {
    return null;
  }
  return (
    <BorderedTransparentBox
      padding={2}
      color={'info'}
      maxWidth={600}
      minWidth={300}
      {...dataAttrs('proposal-scenario-next-up-insight')}
    >
      <FDStack spacing={2} alignItems={'flex-start'}>
        {resource.withRelationship(fr.relationships.plannerProfileImage.name,
          (rel) => <FDAvatar alt={rel.meta('altText')} src={rel.link('related').url()} size={'sm'} />,
          () => null)}
        <MetaControl resource={resource} attrName={'nextUpCustomInsight'} metaOverrideSet={metaOverrides} />
      </FDStack>
    </BorderedTransparentBox>
  );
};

NextUpInsight.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
